import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-84808ca4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-10" }
const _hoisted_2 = { class: "card-body d-flex align-items-center py-8" }
const _hoisted_3 = { class: "d-flex h-80px w-80px flex-shrink-0 flex-center position-relative mx-5" }
const _hoisted_4 = { class: "svg-icon svg-icon-primary position-absolute opacity-15" }
const _hoisted_5 = { class: "svg-icon svg-icon-3x svg-icon-primary position-absolute" }
const _hoisted_6 = { class: "ms-6 mx-5" }
const _hoisted_7 = { class: "list-unstyled text-gray-600 fw-bold fs-5 p-0 m-0" }
const _hoisted_8 = { class: "row g-5 g-xl-8 mb-8" }
const _hoisted_9 = {
  key: 0,
  class: "col-xl-12"
}
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "d-flex justify-content-center mt-15 mb-15" }
const _hoisted_13 = { class: "card-title fw-bolder text-muted text-hover-primary fs-4 mt-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mt-15 mb-15" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border spinner-lg",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1))
const _hoisted_15 = {
  key: 0,
  class: "row g-5 g-xl-8"
}
const _hoisted_16 = { class: "col-xl-8" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = {
  class: "card-xl-stretch mb-xl-8 card bgi-no-repeat",
  style: {"background-image":"url('media/svg/shapes/abstract-2.svg')","background-position":"right top","background-size":"90px"}
}
const _hoisted_19 = {
  class: "card-header border-0",
  style: {"position":"absolute","right":"0"}
}
const _hoisted_20 = { class: "card-toolbar" }
const _hoisted_21 = {
  class: "card-body",
  style: {"padding-bottom":"0px"}
}
const _hoisted_22 = {
  href: "#",
  class: "card-title fw-bolder text-muted text-hover-primary fs-4"
}
const _hoisted_23 = { class: "fw-bolder text-primary my-6" }
const _hoisted_24 = { class: "col-xl-4" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "card mb-5" }
const _hoisted_27 = {
  class: "card-xl-stretch mb-xl-8 card bgi-no-repeat",
  style: {"background-image":"url('media/svg/shapes/abstract-3.svg')","background-position":"right top","background-size":"90px"}
}
const _hoisted_28 = {
  class: "card-body",
  style: {"padding-bottom":"0px"}
}
const _hoisted_29 = { class: "mb-1" }
const _hoisted_30 = {
  class: "text-gray-900",
  style: {"font-size":"1.3rem"}
}
const _hoisted_31 = {
  class: "text-gray-700",
  style: {"font-size":"1.2rem"}
}
const _hoisted_32 = {
  style: {"font-size":"1.3rem","color":"black"},
  class: "mb-1"
}
const _hoisted_33 = { class: "text-gray-900" }
const _hoisted_34 = { class: "text-gray-700" }
const _hoisted_35 = {
  key: 0,
  class: "card mb-5"
}
const _hoisted_36 = {
  class: "card-xl-stretch mb-xl-8 card bgi-no-repeat",
  style: {"background-image":"url('media/svg/shapes/abstract-4.svg')","background-position":"right top","background-size":"90px"}
}
const _hoisted_37 = {
  class: "card-body",
  style: {"padding-bottom":"0px"}
}
const _hoisted_38 = {
  style: {"font-size":"1.75rem","color":"black"},
  class: "mb-1"
}
const _hoisted_39 = {
  style: {"font-size":"1.1rem"},
  class: "text-gray-600"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = {
  class: "card",
  style: {"width":"100%"}
}
const _hoisted_42 = {
  class: "card-xl-stretch mb-xl-8 card bgi-no-repeat",
  style: {"background-image":"url('media/svg/shapes/abstract-1.svg')","background-position":"right top","background-size":"90px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_printBulletin = _resolveComponent("printBulletin")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_marksChart = _resolveComponent("marksChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, {
              src: "media/icons/duotune/abstract/abs051.svg",
              class: "h-80px w-80px"
            })
          ]),
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/coding/cod002.svg" })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t("report.informations")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!_ctx.available || _ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.loading)
                ? (_openBlock(), _createBlock(_component_el_empty, {
                    key: 0,
                    description: _ctx.t('report.unavailable')
                  }, null, 8, ["description"]))
                : (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t("dashboard.report")), 1)
                      ]),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.available && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.type === 'MP')
                      ? (_openBlock(), _createBlock(_component_printBulletin, {
                          key: 0,
                          bulletin: _ctx.bulletin,
                          type: _ctx.type
                        }, null, 8, ["bulletin", "type"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("a", _hoisted_22, _toDisplayString(_ctx.t("dashboard.report")), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.capitalize(_ctx.bulletin.fullName)), 1),
                  _createVNode(_component_el_table, {
                    data: _ctx.marksData,
                    style: {"width":"100%"},
                    "row-class-name": _ctx.tableRowClassName
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "subjectName",
                        label: _ctx.t('subject')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "mark",
                        label: _ctx.t('report.yourStudentMark')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "min",
                        label: _ctx.t('report.minMark')
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        prop: "max",
                        label: _ctx.t('report.maxMark')
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data", "row-class-name"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t("report.classroomName")) + " : ", 1),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.bulletin.classroomName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.t("report.nbrStudents")) + " : ", 1),
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.bulletin.students), 1)
                    ])
                  ])
                ])
              ]),
              (_ctx.bulletin.moyenne)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("report.moyenneTrimestre", { moyenne: _ctx.bulletin.moyenne })), 1),
                        _createElementVNode("div", _hoisted_39, [
                          _createTextVNode(_toDisplayString(_ctx.$t("report.moyenneMax", {
                    moyenne: _ctx.bulletin.maxMoyenne,
                  })), 1),
                          _hoisted_40,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("report.moyenneMin", {
                    moyenne: _ctx.bulletin.minMoyenne,
                  })), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_marksChart, { marksData: _ctx.marksData }, null, 8, ["marksData"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}